import { CartLineModel } from "@insite/client-framework/Types/ApiModels";
import ga from "@starter/Framework/Common/GoogleAnalytics";

const mapCartLineModel = (
    cartLine: CartLineModel,
    options?: Toolkit.GoogleAnalytics.Options,
): Toolkit.GoogleAnalytics.Item => {
    const {
        availability,
        brand,
        erpNumber,
        id,
        isActive,
        isDiscontinued,
        isRestricted,
        notes,
        pricing,
        productId,
        qtyOrdered,
        shortDescription,
        unitOfMeasure,
    } = cartLine;

    return {
        discontinued: isDiscontinued || undefined,
        has_notes: Boolean(notes),
        inactive: !isActive || undefined,
        item_brand: brand?.name,
        item_id: erpNumber,
        item_name: shortDescription,
        quantity: qtyOrdered ?? 1,
        restricted: isRestricted || undefined,
        stock_id: availability?.messageType ?? undefined,
        stock_status: availability?.message || undefined,
        unit_of_measure: unitOfMeasure || undefined,
        price: ga.util.parseAmount(pricing?.unitNetPrice),
        ...ga.util.getItemDiscountParameters(pricing?.unitListPrice, pricing?.unitNetPrice),
        ...ga.map.promotionsOption(options, id),
        ...ga.map.productInfosOption(options, productId),
        ...options?.itemData,
    };
};

export default mapCartLineModel;
